import {isDefined} from "../../../util/isDefined";


export function pullEdition1Columns(columnNames, data, key = undefined) {
    const response = (data || {}).response || {};
    const layers = response.layers || [];
    const layer = key ? layers.find(l => l.name === key) || {} : (layers[0] || {});

    const rows = layer.rows || [];
    const firstRow = rows[0] || {};
    const columns = (firstRow.columns || [])
        .filter(({value}) => isDefined(value))
        .filter(({name}) => columnNames.includes(name));

    if (columns.length) {
        return {
            name: "Historic regional units",
            value: columns.map(({name, value}) => {
                return `${value} (${name})`
            }).join(', ')
        };
    }

    return null;
}
